import { Box, Paper, Typography } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const navigationCardStyle = {
    maxWidth: "260px",
    minWidth: "140px",
    height: "180px",
    backgroundColor: "hsl(218, 53%, 39%)",
    color: "white",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    margin: "15px",
    padding: "15px",
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
    // borderRadius: "50px",
    "&:hover": {
        transform: "scale(1.03)",
        backgroundColor: "hsl(218, 53%, 49%)",
    },
    "&:active": {
        transform: "scale(0.98)",
        backgroundColor: "hsl(218, 53%, 49%)",
        boxShadow: "inset 0 2px 4px rgba(0,0,0,0.3)",
    },
};

export const LandingPageTile = ({
    title,
    query,
    pageUrl,
    showActiveTotalCountFactor = false,
    activeCountKey = "active",
    activeCountLabel = "",
    totalCountKey = "count",
    icon,
    customStyles,
    inconFontSize=90,
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const style = useMemo(() => ({ ...navigationCardStyle, ...customStyles }), [customStyles]);

    const isHomeUrl = (url) => {
        return url.startsWith(window._env_.MY_HOME_FRONTEND_URL);
    };

    const isExternalUrl = (url) => {
        return url.startsWith("http://") || url.startsWith("https://") || url.startsWith("//");
    };

    const handleNavigation = () => {
        if (isHomeUrl(pageUrl)) {
            window.open(pageUrl, "_self", "noopener,noreferrer");
        } else if (isExternalUrl(pageUrl)) {
            window.open(pageUrl, "_blank", "noopener,noreferrer");
        } else {
            navigate(pageUrl);
        }
    };

    return (
        <Paper sx={style} onClick={handleNavigation} elevation={4}>
            <Box display="flex" flexDirection="column" alignItems="center" gap={0}>
                {icon && <Box sx={{ fontSize: inconFontSize, flexShrink: 0 }}>{icon}</Box>}

                <Typography
                    variant="h6"
                    component="h2"
                    textAlign="center"
                    fontWeight="bold"
                    sx={{
                        // minHeight: "2em",
                        display: "flex",
                        alignItems: "center",
                        lineHeight: 1.2,
                    }}
                >
                    {title}
                </Typography>

                <Box sx={{ }}>
                    {query &&
                        (query.isLoading ? (
                            <Typography variant="body2" color="rgba(255,255,255,0.7)">
                                {t("loading")}
                            </Typography>
                        ) : query.isError ? (
                            <Typography variant="body2" color="rgba(255,255,255,0.7)">
                                {t("error_loading_data")}
                            </Typography>
                        ) : showActiveTotalCountFactor && query.data?.[totalCountKey] ? (
                            <div style={{display: "flex", marginBottom: 15}}>
                                <div >
                                    <Typography variant="h6" fontWeight="bold" sx={{"color": "hsla(29, 96%, 46%, 1.00)"}}>{`${query.data?.[activeCountKey]}`}</Typography>
                                    <div style={{position: "relative", alignSelf:"center"}}>
                                        <div style={{position:"absolute", left:"50%", transform: "translateX(-50%)", whiteSpace:"nowrap"}}>
                                            <Typography variant="body2" fontWeight="bold" sx={{textTransform: "uppercase", fontSize: "11px"}}>{activeCountLabel}</Typography>
                                        </div>
                                        
                                    </div>
                                </div>
                                <div style={{marginInline: 4}}>
                                    <Typography variant="h6" fontWeight="bold">{"/"}</Typography>
                                </div>
                                <div>
                                    <Typography variant="h6" fontWeight="bold">{`${query.data?.[totalCountKey]}`}</Typography>
                                </div>
                            </div>
                        ) : (
                            // <div style={{marginBottom: 15}}>
                            <Typography variant="h6" fontWeight="bold">
                                {query.data?.[totalCountKey] || "N/A"}
                            </Typography>
                            // </div>
                        ))}
                        {/* {!query && <div style={{marginBottom: 45}} />} */}
                </Box>
            </Box>
        </Paper>
    );
};
